import React, { useState } from "react";
import EmployeesPanel from "./EmployeesPanel";
import CompImportPanel from "./CompImportPanel";
import CompRecordsGrid from "./CompRecordsGrid";
import CompRecordsList from "./CompRecordsList";

// Compensation tab (F7a): employees, the encoding grid, CSV import and the
// saved rows. Shown only for clients with employees (getWhtProfile).

const CompensationTab = ({ client, year, onOpenPostingAccounts }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey((k) => k + 1);

  return (
    <div>
      <EmployeesPanel client={client} onChanged={refresh} />
      <CompImportPanel client={client} onImported={refresh} />
      <CompRecordsGrid
        key={`${client?._id}-${year}`}
        client={client}
        year={year}
        defaultMonth={new Date().getMonth() + 1}
        onSaved={refresh}
      />
      <CompRecordsList client={client} year={year} refreshKey={refreshKey} onOpenPostingAccounts={onOpenPostingAccounts} />
    </div>
  );
};

export default CompensationTab;
